/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78280 - Estructura Cotizador Arrendamiento Bepensa
*
* Last Modifier: Jennifer Mancilla
* Last Modification: 08/09/2022
*
* Feat: 78282
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/

import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { WelcomeView } from '../views/WelcomeView';
import { store } from '../reducer/store';
import { useAppDispatch } from '../hooks/storeHooks';
import { getDimensions } from '../reducer/slices/dimensions';
import { QouteView } from '../views/QouteView';
import { ProtectedQuoteRoute } from '../routes/ProtectedQuoteRoute';
import { StepProvider } from '../context/stepContext';

const axios = require('axios');
var headers = new Headers({
    'Content-Type': 'application/json',
    'Authorization': 'Basic UG1XYjlUZE5hYURDWTBvZmlwVjVhSmtzZ0xfc1YxTUpQLWoxdjNhOFlFZzpkV0pWS3JyV2JGWndSanVDMjZITmpPQ1VVcHdLR0lQWlkzdjNEZkZScWNz'
})
// Function to call your server-side to generate the access_token and retrieve the your access token
function getAccessToken() {
    // Make sure to change /get-access-token to point to your server-side.
    return axios(`https://sandbox-api.ekatena.com/oauth/token?grant_type=client_credentials`, {
      method: 'POST',
      headers: headers,
      redirect: 'follow'
    })}

const AppRouterBepensa = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        window.addEventListener('resize', updateWimdowSize, false);    
        AccessTokenEkatena()
    }, []);


    const AccessTokenEkatena = async () => {
        const {url, id, pass} = await getAccessToken();
        sessionStorage.setItem("urlEkatena",url);
        sessionStorage.setItem("idEkatena", id);
        sessionStorage.setItem("passEkatena", pass);
    }

    const updateWimdowSize = () => {
        dispatch( getDimensions(window) );
    }

    return (
        <Routes>
            <Route path='/' element={<WelcomeView />} />
            {/* <Route path='/quote' element={<WelcomeView />} /> */}
            <Route
                path="/quote"
                element={
                    <ProtectedQuoteRoute>
                        <QouteView />
                    </ProtectedQuoteRoute>
                }
            />
        </Routes>
    );
}

export const AppRouter = () => {
    return (
        <Provider store={store}>
            <StepProvider>
                <BrowserRouter>
                    <AppRouterBepensa />
                </BrowserRouter>
            </StepProvider>
        </Provider>
    );
}